module.exports = __webpack_public_path__ + "img/shopping.232bbd1d.svg";